import React, { useEffect, useState } from 'react';
import { ShoppingBag } from 'lucide-react';
export function StickyBottomBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Se muestra la barra después de bajar 400px
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 py-4 px-6 transition-all duration-500 animate-in fade-in slide-in-from-bottom-5" data-id="element-116">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-117">
        
        {/* Información en Escritorio */}
        <div className="hidden md:flex flex-col" data-id="element-118">
          <span className="text-sm font-bold text-gray-900 uppercase tracking-widest" data-id="element-119">
            FaceLift Natural: Reto 21 Días
          </span>
          <span className="text-xs text-green-600 font-medium" data-id="element-120">
            🔥 Acceso inmediato disponible
          </span>
        </div>

        <div className="flex items-center gap-4 w-full md:w-auto justify-between md:justify-end" data-id="element-121">
          {/* Precio en Móvil */}
          <div className="flex flex-col md:hidden" data-id="element-122">
            <span className="text-lg font-bold text-gray-900" data-id="element-123">$14.99</span>
            <span className="text-[10px] text-gray-400 line-through" data-id="element-124">
              $29.99
            </span>
          </div>

          {/* 🔴 BOTÓN DE COMPRA: Aquí va tu Permalink de Shopify (E-book) */}
          <a href="https://[TU-TIENDA].myshopify.com/cart/[ID-DEL-EBOOK]:1" className="inline-flex items-center justify-center px-6 py-3 text-sm font-bold text-white bg-gray-900 rounded-full shadow-lg hover:bg-gray-800 hover:-translate-y-1 transition-all duration-300 w-auto md:w-64 gap-2" data-id="element-125">
            <ShoppingBag className="w-4 h-4" data-id="element-126" />
            <span data-id="element-127">Comprar Ahora</span>
          </a>
        </div>
      </div>
    </div>;
}